module.exports = __webpack_public_path__ + "img/logo.7d785c3c.png";